export const BRAND_LEVEL = [
  {
    id: 1,
    label: '1-普通品牌'
  },
  {
    id: 2,
    label: '2-知名品牌'
  },
  {
    id: 3,
    label: '3-轻奢品牌'
  },
  {
    id: 4,
    label: '4-中奢品牌'
  },
  {
    id: 5,
    label: '5-重奢品牌'
  },
];
export const CURATORS_ROLE = 'CURATORS_ROLE';
export const UPDATE_BRAND = 'UPDATE_BRAND'; // 管理品牌
export const VIEW_CATEGORY_MENU = 'VIEW_CATEGORY_MENU'; // 批量修改商品类目
export const UPDATE_INVENTORY = 'UPDATE_INVENTORY'; // 批量修改商品中文名
export const BATCH_PRODUCT_INFOR = 'BATCH_PRODUCT_INFOR'; // 批量更新商品品牌
export const UPDATE_SIZE_CHARTS = 'UPDATE_SIZE_CHARTS'; // 修改尺码表
export const UPDATE_TARGETED_PRICE = "UPDATE_TARGETED_PRICE" // 比价
export const PRODUCT_NAME_OPERATION = {
    COVER: 'COVER',
    APPEND: 'APPEND',
    DELETE: 'DELETE',
    EMPTY: 'EMPTY'
}
export const DEPRECATED_CATEGORY_ID = ['1', '2', '3', '4', '5', '6'];

const isDEBUG = process.env.REACT_APP_SERVER_ENV === 'development';
export const PAPYRUS_ORIGIN = isDEBUG ? 'https://papyrus-dev.bybieyang.com' : ' https://papyrus.bybieyang.com';

export const WEIGHT_SOURCE = {
    LOGISTIC_ESTIMATE: '物流商品称重',
    LOGISTIC_ESTIMATE_CATEGORY: '物流类目称重',
    LOGISTIC_ESTIMATE_CATEGORY_DEFAULT: '物流默认重量',
    LOGISTIC: '物流重量',
    CRAWLER: '爬虫重量',
    ACCURATE: '人工重量',
    CATEGORY: '类目重量',
    INFER_WEIGHT_BY_KEYWORDS: '关键词推测重量',
    INFER_BEAUTY_WEIGHT: '美妆推测重量',
    INFER_WEIGHT_BY_ATTRIBUTE: '属性推测重量',
    INFER_WEIGHT_BY_CATEGORY: '类目推测重量',
    DEFAULT: '默认重量'
}

export const merchantCategories = [
  {
    id: 'merchants_european_origin',
    name: '欧洲商家',
  },
  {
    id: 'merchants_european_shipping_origin',
    name: '欧洲发货地商家',
  },
  {
    id: 'SELLER_SHOP',
    name: 'bgm商家',
  },
  {
    id: 'PARTNER_SHOP',
    name: '传统商家',
  },
  {
    id: 'RETURN_SALE',
    name: '退货商品商家',
  },
  {
    id: 'SELF_SHOP',
    name: '别样自营',
  },
  {
    id: 'merchants_china',
    name: '中国商家',
  },
  {
    id: 'merchants_china_taiwan',
    name: '中国台湾商家',
  },
  {
    id: 'merchants_china_hong_kong',
    name: '中国香港商家',
  },
  {
    id: 'merchants_china_macao',
    name: '中国澳门商家',
  },
  {
    id: 'merchants_hong_kong',
    name: '香港商家',
  },
  {
    id: 'merchants_australian',
    name: '澳大利亚商家',
  },
  {
    id: 'merchants_austria',
    name: '奥地利商家',
  },
  {
    id: 'merchants_canada',
    name: '加拿大商家',
  },
  {
    id: 'merchants_finland',
    name: '芬兰商家',
  },
  {
    id: 'merchants_french',
    name: '法国商家',
  },
  {
    id: 'merchants_holland',
    name: '荷兰商家',
  },
  {
    id: 'merchants_italy',
    name: '意大利商家',
  },
  {
    id: 'merchants_korea',
    name: '韩国商家',
  },
  {
    id: 'merchants_spain',
    name: '西班牙商家',
  },
  {
    id: 'merchants_uk',
    name: '英国商家',
  },
  {
    id: 'merchants_us',
    name: '美国商家',
  },
  {
    id: 'merchants_germany',
    name: '德国商家',
  },
  {
    id: 'merchants_japan',
    name: '日本商家',
  },
  {
    id: 'shipping_and_tax_included',
    name: '包邮包税商家',
  }
]
export const MERCHANT_TYPE = {
    PARTNER_SHOP: '传统商家',
    SELF_SHOP: '自营商家',
    SELLER_SHOP: 'BGM商家'
}

export const MERCHANT_TAG = {
    final_sale: '不退不换',
    shipping_and_tax_included: '包邮包税',
    beyond_special_price: '别样专享价'
}

export const PROCESSING_FEE_TYPE = {
    PROCESSING_FEE: '商家手续费',
    LOGISTIC_CB_PARTNER: '物流渠道手续费',
    DUTY_INSURANCE: '商家特殊服务费'
}

export const CHECKOUT_MOCK_ADDRESS = {
    CN: {
        areas: [{
            name: '中国',
            code: 'CN'
        }, {
            name: '上海',
            code: '310000'
        }, {
            name: '上海市',
            code: '310100'
        }, {
            name: '浦东新区',
            code: '310115'
        }],
        line1: '张江高科创新园10号楼12层',
        recipientPhone: '13341918101',
        zipCode: '200120',
        dialingCode: '+86',
        recipient: '张三',
        recipientIdNumber: '31010119900307145X',
        payer: '张三',
        payerIdNumber: '31010119900307145X'
    },
    HK: {
        areas: [{
            name: '中国香港',
            code: 'HK'
        }, {
            name: 'Hong Kong',
            code: ''
        }, {
            name: 'Hong Kong Island',
            code: ''
        }, {
            name: 'Eastern District',
            code: ''
        }],
        line1: 'Room 100, Floor 100, Mei Sang House',
        recipientPhone: '64523188',
        dialingCode: '+852',
        recipient: '张三',
        recipientIdNumber: '31010119900307145X',
        payer: '张三',
        payerIdNumber: '31010119900307145X'
    },
    US: {
        areas: [{
            name: 'United States',
            code: 'US'
        }, {
            name: 'Alabama',
            code: 'AL'
        }, {
            name: 'Abbeville',
            code: ''
        }],
        line1: 'avenue Floor 100, Room 100',
        recipientPhone: '4158888888',
        dialingCode: '+1',
        recipient: 'zhangsan',
        zipCode: '35240'
    }
}

export const SHIPPING_METHOD_NAME = {
    BIEYANG: '普通平邮',
    SUNSHINE_CUSTOM: '便捷直邮'
}